import { render } from "./footer.vue?vue&type=template&id=da3cae56"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=da3cae56&lang=css"

import exportComponent from "/home/forge/test.rwandabuildprogram.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__